import { getIsUserBlacklisted } from "@stadium/services/analytics/helpers/blacklisted-users";

import { JUNE_SO, MIXPANEL } from "@stadium/services/analytics/constants/services";

const useUserIdentification = (services) => {
  const identifyUser = ({ userId = "", userProperties = {}, additionalProps = {} } = {}) => {
    services.map((service) => {
      if (service === JUNE_SO) {
        if (!getIsUserBlacklisted({ companyName: additionalProps?.companyName })) {
          return globalThis?.analytics?.identify?.(userId, userProperties);
        }
      }

      if (service === MIXPANEL) {
        if (userId) {
          globalThis?.mixpanel?.identify?.(userId);
        }
        // Use Mixpanel reserved properties ($email, $name) for proper profile display
        const mixpanelPeopleProps = {
          ...(userProperties.email && { $email: userProperties.email }),
          ...(userProperties.name && { $name: userProperties.name }),
          ...userProperties,
        };
        globalThis?.mixpanel?.people?.set?.(mixpanelPeopleProps);
      }
    });
  };
  const groupUser = ({ companyId = "", companyProperties = {} } = {}) => {
    services.map((service) => {
      if (service === JUNE_SO) {
        if (!getIsUserBlacklisted({ companyName: companyProperties?.name })) {
          return globalThis?.analytics?.group?.(companyId, companyProperties);
        }
      }
      if (service === MIXPANEL && companyId) {
        globalThis?.mixpanel?.get_group?.("company", companyId)?.set?.(companyProperties);
      }
    });
  };
  return { identifyUser, groupUser };
};

export default useUserIdentification;
